import { FC } from "react";

import { PrescriberInfoProps } from "./types";
import { DEFAULT_DRUG_NAME } from "src/constants/cases";

const ShowPrescriberInformation: FC<PrescriberInfoProps> = ({ getValues }): JSX.Element => {
  const { prescription_attributes, shipments_attributes } = getValues();
  return (
    <div className="card my-3">
      <div className="card-header bg-success-subtle">
        <h3 className="text-black m-0">Prescription Information</h3>
      </div>
      <div className="card-body">
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Drug:</label>
              </div>
              <div className="col-6">
                {DEFAULT_DRUG_NAME}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Benefits being requested:</label>
              </div>
              <div className="col-6">
                <p>Both</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Schedule Date of Service:</label>
              </div>
              <div className="col-6">
                <p></p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
          <div className="row">
              <div className="col-6">
                <label className="form-label">Injection Site:</label>
              </div>
              <div className="col-6">
                <p></p>
              </div>
          </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Quantity:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.qty ? prescription_attributes.qty : "N/A"}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Diagnosis Code (ICD):</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.diagnosis_code ? prescription_attributes.diagnosis_code.join(", ") : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Written date:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.written_date ? prescription_attributes.written_date : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Ship To:</label>
              </div>
              <div className="col-6">
                <p>{shipments_attributes && shipments_attributes[0] && shipments_attributes[0].ship_to ? 
                  (shipments_attributes[0].ship_to === "other" ?
                    `${shipments_attributes[0].ship_to_street || ""}${shipments_attributes[0].ship_to_suite ? `, ${shipments_attributes[0].ship_to_suite}` : ""}, ${shipments_attributes[0].ship_to_city || ""}, ${shipments_attributes[0].ship_to_state || ""}, ${shipments_attributes[0].ship_to_zip || ""}`
                    : shipments_attributes[0].ship_to
                  )
                  : 'N/A'
                }</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Directions:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.direction ? prescription_attributes.direction : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Notes:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.note ? prescription_attributes.note : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowPrescriberInformation;
